export const getFuelType = (enums, fuelType) => {
  if (enums?.fuelTypes?.length) {
    const enumFuelType = enums?.fuelTypes?.find((item) => {
      return item?.name === fuelType;
    });
    return enumFuelType?.id;
  }
  return null;
};

export const getCategory = (enums, category) => {
  if (enums?.categories?.length) {
    const enumCategories = enums?.categories?.find((item) => {
      return item?.name === category;
    });
    return enumCategories?.id;
  }
  return null;
};

export const getEuroClass = (enums, euroClass) => {
  if (enums?.euroClasses?.length) {
    const enumEuroclasses = enums?.euroClasses?.find((item) => {
      return item?.name === euroClass;
    });
    return enumEuroclasses?.id;
  }
  return null;
};

export const getAvailability = (enums, availability) => {
  if (enums?.availabilities?.length) {
    const enumAvailability = enums?.availabilities?.find((item) => {
      return item?.name === availability;
    });
    return enumAvailability?.id;
  }
  return null;
};

export const getEngineType = (enums, engineType) => {
  if (enums?.engineTypes?.length) {
    const enumEngineTypes = enums?.engineTypes?.find((item) => {
      return item?.name === engineType;
    });
    return enumEngineTypes?.id;
  }
  return null;
};

export const getTransmission = (enums, transmission) => {
  if (enums?.transmissions?.length) {
    const enumTransmissions = enums?.transmissions?.find((item) => {
      return item?.name === transmission;
    });
    return enumTransmissions?.id;
  }
  return null;
};

export const getWheelDrives = (enums, wheelDrive) => {
  if (enums?.wheelDrives?.length) {
    const enumWheelDrive = enums?.wheelDrives?.find((item) => {
      return item?.name === wheelDrive;
    });
    return enumWheelDrive?.id;
  }
  return null;
};
export const getBodyType = (enums, bodyType) => {
  if (enums?.bodyTypes?.length) {
    const enumBodyTypes = enums?.bodyTypes?.find((item) => {
      return item?.name === bodyType;
    });
    return enumBodyTypes?.id;
  }
  return null;
};

export const getBodySize = (enums, bodySize) => {
  if (enums?.bodySizes?.length) {
    const enumBodySize = enums?.bodySizes?.find((item) => {
      return item?.name === bodySize;
    });
    return enumBodySize?.id;
  }
  return null;
};

export const getProductLines = (enums, productLine) => {
  if (enums?.productLines?.length) {
    const enumProductLine = enums?.productLines?.find((item) => {
      return item?.name === productLine;
    });
    return enumProductLine?.id;
  }
  return null;
};

export const getCategoryClass = (enums, categoryClass) => {
  const categoryClassKeys = Object.keys(enums?.categoryClasses);
  if (categoryClassKeys?.length) {
    const enumCategoryClass = categoryClassKeys?.find((key) => {
      return enums?.categoryClasses[key]?.slug === categoryClass;
    });
    return enumCategoryClass?.id;
  }
  return null;
};

export const getRiskCategory = (enums, riskCategory) => {
  if (enums?.riskCategories?.length) {
    const enumRiskCategory = enums?.riskCategories?.find((item) => {
      return item?.slug === riskCategory;
    });
    return enumRiskCategory?.value;
  }
  return null;
};
